import React, {useEffect, memo} from 'react';

import css from "./ShowText.module.css"
import {machine as m} from "../../../constants/machine.constants";
import {useMainStateMachine} from "../../MainStateMachineProvider";
import {useSelector} from "@xstate/react";
import {getDataByRole} from "../../../services/scenarioItemService";

const ShowText = memo(({dataItem, cardIndex, scenarioIndex, field, overrideText, overrideWords}) => {
    const {actor, send} = useMainStateMachine();

    // 1. Возвращаем слово ВСЕГДА, пока компонент смонтирован.
    const wordFromContext = useSelector(actor, (s) => 
        (dataItem && field) ? getDataByRole(dataItem, field, s.context) : null,
        (a, b) => JSON.stringify(a) === JSON.stringify(b)
    );

    const word = overrideText ? {title: overrideText, words: overrideWords || []} : wordFromContext;

    const isActive = useSelector(actor, (s) =>
        cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex
    );
    
    const isPlayingScenario = useSelector(actor, (s) => {
        const active = cardIndex === s.context.currentCardIndex && scenarioIndex === s.context.currentScenarioIndex;
        return active && s.matches(m.state.playingScenario);
    });

    useEffect(() => {
        if (isActive && isPlayingScenario) {
            send({type: m.events.NEXT_STEP})
        }
    }, [isActive, isPlayingScenario, send]);

    // console.log(`ShowText [ID:${cardIndex} SIdx:${scenarioIndex}] render:#${renderCount}`, {isActive})

    const {title = "", words = []} = word || {};

    const getColorText = (field) => {
        const mapColorsByField = {
            study: "var(--text-color)",
            base: "var(--dropdown-color)",

            // study: "var(--primary-color)",
            // base: "var(--secondary-color)"
        }

        return mapColorsByField[field] || "var(--text-color)"
    }

    const highlightWords = (text, words) => {
        const regex = new RegExp(`(${words.join('|')})`, 'gi'); // Создаем регулярное выражение для поиска слов
        const parts = text.split(regex); // Разделяем текст на части по совпадениям

        return parts.map((part, index) => {
            // Если часть совпадает с одним из слов, оборачиваем в <span> с классом для подсветки
            if (words.some(word => word.toLowerCase() === part.toLowerCase())) {
                return <span key={index} style={{
                    fontStyle: "italic",
                    textDecoration: "underline  var(--error-color)"
                }}>{part}</span>;
            }
            return part; // Возвращаем часть текста без изменений
        });
    };

    return (
        <div className={css.show_text} style={{color: getColorText(field)}}>
            {highlightWords(title, words)}
        </div>
    );
});

const showTextProps = ["word", "cardIndex", "scenarioIndex", "field"]

export {ShowText, showTextProps};